let caps = false;
let sound = false;
let mobileSound = false;
let soundClicked = false;
let mobileSoundClicked = false;
let entries = 0;

let str = "";

const textInput = document.querySelector("#textIn");
const keys = document.querySelectorAll(".key");
const fucntionalKey = document.querySelectorAll(".key-fN");
const capLockDot = document.querySelector(".capLock-dot");
const entriesCounter = document.querySelectorAll(".entries-Counter");

const sectEntry = document.querySelector("#sect-Entry");
// const keyboard = document.querySelector(".keyboard");
const checkBox = document.querySelector("#checkBox");
const mobileCheckBox = document.querySelector("#mobile-checkBox");
const soundBtn = document.querySelector("#soundBtn");
const mobileSoundBtn = document.querySelector("#mobile-soundBtn");

const mobileSndIcon = document.querySelector("#mobile-snd-Icon");
const sndIcon = document.querySelector("#snd-Icon");
const clearBtn = document.querySelector("#clearBtn");
const hamburger = document.querySelector("#hamburger-icon");

const deleteBtnArr = [];

function toggleMobileMenu(menu) {
  menu.classList.toggle("open");
}

hamburger.addEventListener("click", (e) => {
  hamburger.classList.toggle("open");
  console.log(e.target);
});

const addToLocalStorageObject = (name, key, value) => {
  // Get the existing data
  let existing = localStorage.getItem(name);
  // If no existing data, create an array
  // Otherwise, convert the localStorage string to an array
  existing = existing ? JSON.parse(existing) : {};
  // Add new data to localStorage Array
  existing[key] = value;
  // Save back to localStorage
  localStorage.setItem(name, JSON.stringify(existing));
};

const getLocalStorageObj = () => {
  let state = localStorage.getItem("state");
  if (state) {
    return JSON.parse(localStorage.getItem("state"));
  } else {
    return {};
  }
};

const state = getLocalStorageObj();

const getLocalStorage = () => {
  let entry = localStorage.getItem("entry");
  if (entry) {
    return JSON.parse(localStorage.getItem("entry"));
  } else {
    return [];
  }
};

const entry = getLocalStorage();

const isExistLocalStorage = (key) => localStorage.getItem(key) != null;
const createOrEditLocalStorage = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value));
const getValeuLocalStorage = (key) => JSON.parse(localStorage.getItem(key));

checkBox.addEventListener("click", ({ target }) => {
  target.checked
    ? (mobileCheckBox.checked = true)
    : (mobileCheckBox.checked = false);
});

mobileCheckBox.addEventListener("click", ({ target }) => {
  target.checked ? (checkBox.checked = true) : (checkBox.checked = false);
});

const darkMode = () => {
  document.body.style.backgroundColor = "#343434";
  if (textInput) textInput.style.backgroundColor = "#343434";
};
// SWITCH THIS AROUND THEN FINISH
const lightMode = () => {
  document.body.style.backgroundColor = "#FCFCFC";
  if (textInput) textInput.style.backgroundColor = "#FCFCFC";
};

mobileCheckBox.addEventListener("change", ({ target }) => {
  target.checked ? darkMode() : lightMode();
});

mobileCheckBox.addEventListener("change", ({ target }) => {
  target.checked ? darkMode() : lightMode();
  target.checked
    ? createOrEditLocalStorage("mode", "darkMode")
    : createOrEditLocalStorage("mode", "lightMode");
});
checkBox.addEventListener("change", ({ target }) => {
  target.checked ? darkMode() : lightMode();
  target.checked
    ? createOrEditLocalStorage("mode", "darkMode")
    : createOrEditLocalStorage("mode", "lightMode");
});

if (!isExistLocalStorage("mode")) createOrEditLocalStorage("mode", "lightMode");
if (getValeuLocalStorage("mode") === "lightMode") {
  mobileCheckBox.removeAttribute("checked");
  checkBox.removeAttribute("checked");

  lightMode();
  // run some test my have  add in a ln for cb or make a func to hold these lines
} else {
  mobileCheckBox.setAttribute("checked", "");
  checkBox.setAttribute("checked", "");

  darkMode();
}

// Sound
const keySound = () => {
  const keyAudio = new Audio("src/vintage-typewriter.wav");
  if (sound || mobileSound) keyAudio.play();
  // if (mobileSound) keyAudio.play();
};

const soundChangeLogic = () => {
  if (sound) {
    sndIcon.innerHTML = "volume_up";
    sndIcon.style.color = "white";
  } else if (!sound) {
    sndIcon.innerHTML = "volume_mute";
    sndIcon.style.color = "red";
  }
  if (mobileSound) {
    mobileSndIcon.innerHTML = "volume_up";
    mobileSndIcon.style.color = "white";
  } else if (!mobileSound) {
    mobileSndIcon.innerHTML = "volume_mute";
    mobileSndIcon.style.color = "red";
  }
};

checkBox.addEventListener("click", ({ target }) => {
  target.checked
    ? (mobileCheckBox.checked = true)
    : (mobileCheckBox.checked = false);
});

mobileCheckBox.addEventListener("click", ({ target }) => {
  target.checked ? (checkBox.checked = true) : (checkBox.checked = false);
});

const soundTrue = () => {
  mobileSoundClicked = true;
  mobileSound = true;
  soundClicked = true;
  sound = true;
};

const soundFalse = () => {
  mobileSoundClicked = false;
  mobileSound = false;
  soundClicked = false;
  sound = false;
};

mobileSoundBtn.addEventListener("click", (e) => {
  if (!mobileSoundClicked) {
    soundTrue();
    createOrEditLocalStorage("sound", "on");
  } else if (mobileSoundClicked) {
    soundFalse();
    createOrEditLocalStorage("sound", "quiet");
  }
  soundChangeLogic();
});

soundBtn.addEventListener("click", (e) => {
  if (!soundClicked) {
    soundTrue();
    createOrEditLocalStorage("sound", "on");
  } else if (soundClicked) {
    soundFalse();
    createOrEditLocalStorage("sound", "quiet");
  }
  soundChangeLogic();
});

if (!isExistLocalStorage("sound")) createOrEditLocalStorage("sound", "quite");
if (getValeuLocalStorage("sound") === "quite") {
  mobileSound = false;
  sound = false;
} else if (getValeuLocalStorage("sound") === "on") {
  mobileSound = true;
  sound = true;
}

soundChangeLogic();

const entryLogic = () => {
  if (sectEntry) {
    console.log(entry);
    console.log(sectEntry);
    console.log(document.querySelectorAll(".del-Btn"));

    entry.map((entry) => {
      const entryBox = document.createElement("div");
      const entryText = document.createElement("p");
      const entryDeleteBtn = document.createElement("button");
      entryBox.classList.add("entryBox");
      entryText.classList.add("entryText");
      entryDeleteBtn.classList.add("del-Btn", "btn");
      deleteBtnArr.push(entryDeleteBtn);

      entryDeleteBtn.textContent = "X";
      entryText.textContent = entry;
      entryBox.appendChild(entryText);
      entryBox.appendChild(entryDeleteBtn);
      sectEntry.appendChild(entryBox);
    });
  }

  if (deleteBtnArr) {
    console.log(deleteBtnArr);
    deleteBtnArr.map((del, index) => {
      del.addEventListener("click", () => {
        entry.splice(del[index], 1);
        localStorage.setItem("entry", JSON.stringify(entry));
        window.location.reload();
      });
    });
  }

  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      localStorage.removeItem("entry");
      window.location.reload();
    });
  }

  if (entry.length > 0) {
    entries = entry.length;
    entriesCounter.forEach((entry) => {
      entry.textContent += entries;
    });
  }
};

const addEntry = () => {
  entry.push(textInput.value);
  localStorage.setItem("entry", JSON.stringify(entry));
};

fucntionalKey.forEach((funcKey) => {
  funcKey.addEventListener("click", () => {
    keySound();
    if (funcKey.classList.contains("backspace") && str.length > 0) {
      str = str.slice(0, -1);
      textInput.value = str;
    } else if (funcKey.classList.contains("caps")) {
      keys.forEach((key) => {
        key.classList.toggle("cap");
        if (key.classList.contains("cap")) {
          key.value = key.value.toLocaleUpperCase();
          caps = true;
          capLockDot.style.color = "red";
        } else if (!key.classList.contains("cap")) {
          key.value = key.value.toLocaleLowerCase();
          caps = false;
          capLockDot.style.color = "white";
        }
        console.log(caps);
      });
      textInput.value = str;
    } else if (funcKey.classList.contains("shift")) {
      const k2 = Array.from(document.querySelector(".k2").children);
      const k3 = Array.from(document.querySelector(".k3").children);
      const k4 = Array.from(document.querySelector(".k4").children);
      // k2
      const shiftK2 = ["-", "/", "_", ":", ";", "(", ")", "$", "&", "@", '"'];
      const copyK2 = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"];
      // k3
      const shiftK3 = ["[", "]", "{", "}", "#", "%", "^", "*", "+"];
      const copyK3 = ["a", "s", "d", "f", "g", "h", "j", "k", "l"];

      const shiftK4 = ["=", "~", "\\", "|", "<", ">", "`", ",", ".", "?"];
      const copyK4 = ["z", "x", "c", "v", "b", "n", "m", ",", ".", "?"];
      const modifiyKeys = (keyArr, array) => {
        keyArr.map((key, index) => {
          key.innerHTML = array[index];
          key.value = array[index];
        });
      };

      const modifiyKeysMinusOne = (keyArr, array) => {
        keyArr.map((key, index) => {
          if (!keyArr[index].classList.contains("key-fN")) {
            key.innerHTML = array[index - 1];
            key.value = array[index - 1];
          }
        });
      };

      const modifiyKeysCaps = (keyArr, array) => {
        keyArr.map((key, index) => {
          if (!keyArr[index].classList.contains("key-fN"))
            key.value = array[index - 1].toUpperCase();
        });
      };

      if (k2[0].innerHTML === "q") {
        modifiyKeys(k2, shiftK2);
      } else if (k2[0].innerHTML === "-") {
        modifiyKeys(k2, copyK2);
      }
      // this line is to make sure when caps is true and shift is pressed the val reflects the innerHTML
      if (caps && k2[0].innerHTML === "q") {
        k2.map((key, index) => {
          key.value = copyK2[index].toUpperCase();
        });
      }
      if (k3[1].innerHTML === "a") {
        modifiyKeysMinusOne(k3, shiftK3);
      } else if (k3[1].innerHTML === "[") {
        modifiyKeysMinusOne(k3, copyK3);
      }
      //Refer to ln 326
      if (caps && k3[1].innerHTML === "a") {
        modifiyKeysCaps(k3, copyK3);
      }

      if (k4[1].innerHTML === "z") {
        modifiyKeysMinusOne(k4, shiftK4);
      } else if (k4[1].innerHTML === "=") {
        modifiyKeysMinusOne(k4, copyK4);
      }
      //Refer to ln 326
      if (caps && k4[1].innerHTML === "z") {
        modifiyKeysCaps(k4, copyK4);
      }
    } else if (funcKey.classList.contains("space")) {
      // fix this so it adds more spaces on every click for v2
      str += " ";
    } else if (funcKey.classList.contains("enter")) {
      if (str.length > 0) {
        addEntry();
        str = "";
        textInput.value = "";
        window.location.reload();
      }
    }
  });
});

keys.forEach((key) => {
  key.addEventListener("click", () => {
    keySound();
    str += key.value;
    textInput.value = str;
  });
});
entryLogic();

